import styled, { css } from 'styled-components';
import { BREAKPOINTS } from '@titelmedia/bricks-theme/lib/variables/breakpoints';

const setPositionHorizontal = position => {
  switch (position) {
    case 'left':
      return css`
        justify-content: flex-start;
      `;
    case 'center':
      return css`
        justify-content: center;
      `;
    case 'right':
      return css`
        justify-content: flex-end;
      `;
    default:
      return;
  }
};

const setPositionVertical = position => {
  switch (position) {
    case 'top':
      return css`
        align-items: flex-start;
      `;
    case 'center':
      return css`
        align-items: center;
      `;
    case 'bottom':
      return css`
        align-items: flex-end;
      `;
    default:
      return;
  }
};

export const Wrapper = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  min-height: 100vh;
  ${props => props.customCss};
`;

export const ContainerWrapper = styled.div`
  min-height: 100vh;
  position: relative;
  margin: 0 auto;
  display: flex;
  width: 100%;
  max-width: 80vw;
  @media (max-width: ${BREAKPOINTS.xs}px) {
    min-height: ${props => {
      return `calc(${100 / props.aspectRatio}vw - ${
        40 / props.aspectRatio
      }px);`;
    }};
  }
  ${props => setPositionHorizontal(props.staticPosition)};
  @media (max-width: ${BREAKPOINTS.sm}px) {
    justify-content: center;
    align-items: center;
    height: 100%;
    min-height: 100%;
    max-width: 100vw;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    align-items: flex-start;
    min-height: inherit;
    height: fit-content;
  }
`;

export const ImageContainer = styled.div`
  position: absolute;
  @media (max-width: ${BREAKPOINTS.md}px) {
    height: -webkit-fill-available;
    max-width: 100vw;
  }
  @media (max-width: ${BREAKPOINTS.xs}px) {
    width: 100%;
  }
`;

export const Image = styled.img`
  max-width: 100%;
  height: 100vh;
  @media (max-width: ${BREAKPOINTS.md}px) {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ImageItem = styled.img`
  width: ${props =>
    `calc(${10 * props.aspectRatio}vh - ${10 * props.aspectRatio}px);`};
`;

export const WrapperOverlay = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  position: relative;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    height: 100vh;
  }
  ${props => setPositionHorizontal(props.overlayHorizontal)};
  ${props => setPositionVertical(props.overlayVertical)};
`;

export const OverlayContainer = styled.div`
  padding: 80px 0;
  display: flex;
  flex-direction: ${props =>
    props.overlayAlignment === 'inline' ? 'row' : 'column'};
  align-items: center;
`;
